module.exports = __webpack_public_path__ + "static/media/storyline-section-3.6bd3556b.png";